import { pureRenderProps } from '@type-r/react';
import * as React from 'react';
import { OrgInfo } from 'api';
import { CollapsableSection, Column, Columns, FormInput, Subsection } from 'lqx-react';

export const CollapsableAddress =
  pureRenderProps({
      id : String,
      title : String,
      model : OrgInfo
    },
    ({ id, title, model, children }) => {
      const { address, contact } = model;

      return (
        <CollapsableSection id={id} title={title} info={model.name}>
          { children }
          <Subsection title="Address">
            <Columns>
              <Column>
                <FormInput label="Name" $value={model.$.name} />
                <FormInput label="Address Line 1" $value={address.$.line_one} />
                <FormInput label="Address Line 2" $value={address.$.line_two} />
                <FormInput label="City" $value={address.$.city} />
              </Column>
              <Column>
                <FormInput label="State" $value={address.$.state_province} />
                <FormInput label="Postal Code" $value={address.$.postal_code} />
                <FormInput label="Country" $value={address.$.country} />
              </Column>
            </Columns>
          </Subsection>

          <Subsection title="Contact Information">
            <Columns>
              <Column>
                <FormInput label="Name" $value={contact.$.name} />
                <FormInput label="Email" $value={contact.$.email} />
              </Column>
              <Column>
                <FormInput label="Phone" $value={contact.$.phone} />
              </Column>
            </Columns>
          </Subsection>
        </CollapsableSection>
      )
    })
